import React, { useEffect } from 'react';
import { Container, Sidebar, Sidenav, Content, Navbar, Nav, Message, Tooltip, Whisper, Divider, Button } from 'rsuite';

import CogIcon from '@rsuite/icons/legacy/Cog';
import AngleLeftIcon from '@rsuite/icons/legacy/AngleLeft';
import AngleRightIcon from '@rsuite/icons/legacy/AngleRight';
import GearCircleIcon from '@rsuite/icons/legacy/GearCircle';
import FolderFillIcon from '@rsuite/icons/FolderFill';
import { Link, useOutlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logoutAction } from 'Components/login/state/loginAction';
import { useNavigate } from 'react-router-dom';
import api from '../_helpers/api';
import './styles.css';
import './container.less';

import { requestCertAsync, selectData } from 'slices/certSlice';
import {
  requestSignServiceHandshakeAsync,
  selectSignService,
  requestMHRecepcionServiceHandshakeAsync,
  selectMHRecepcionService,
} from 'slices/appSlice';

import HelpOutlineIcon from '@rsuite/icons/HelpOutline';
import TextImageIcon from '@rsuite/icons/TextImage';
import UserBadgeIcon from '@rsuite/icons/UserBadge';
import SingleSourceIcon from '@rsuite/icons/SingleSource';
import ExitIcon from '@rsuite/icons/Exit';
const isDarkSchemePrefered = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
const headerStyles = {
  padding: 5,
  height: 56,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: '#2C4A96',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
};

const contentStyles = {
  maxHeight: '100vh',
  overflow: 'scroll',
  background: isDarkSchemePrefered ? '#212124' : '#F7F7FA',
};

const NavLink = React.forwardRef(({ href, children, ...rest }, ref) => (
  <Link ref={ref} to={href} {...rest}>
    {children}
  </Link>
));

const NavToggle = ({ expand, onChange }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logoutAction()).then((res) => {
      navigate('/login');
    });
  };

  return (
    <Navbar className="nav-toggle">
      <Nav>
        <Nav.Menu noCaret placement="topStart" trigger="click" title={<CogIcon style={{ width: 20, height: 20 }} size="sm" />}>
          <Nav.Item icon={<HelpOutlineIcon />} onSelect={() => window.open(`https://factura.gob.sv/normativa/`, '_blank')}>
            Normativa DTE
          </Nav.Item>
          <Nav.Item icon={<TextImageIcon />} onSelect={() => window.open(`https://admin.factura.gob.sv/consultaPublica`, '_blank')}>
            Consulta DTE - Ministerio de Hacienda
          </Nav.Item>
          <Divider />
          <Nav.Item icon={<HelpOutlineIcon />} onSelect={() => window.open(`https://detecnomx.zohodesk.com/portal/es/home`, '_blank')}>
            Ayuda
          </Nav.Item>
          <Nav.Item
            icon={<TextImageIcon />}
            onSelect={() => window.open(`https://sites.google.com/a/detecno.com/aplicaciones-detecno/dte`, '_blank')}
          >
            Site Detecno Manager DTE
          </Nav.Item>
          <Nav.Item icon={<SingleSourceIcon />} onSelect={() => window.open(`${api.getUri()}swagger/index.html`, '_blank')}>
            Documentacion API
          </Nav.Item>
          <Divider />
          <Nav.Item icon={<ExitIcon />} onSelect={handleLogout}>
            Cerrar sesión
          </Nav.Item>
        </Nav.Menu>
      </Nav>
      <Nav pullRight>
        <Nav.Item onClick={onChange} style={{ width: 56, textAlign: 'center' }}>
          {expand ? <AngleLeftIcon /> : <AngleRightIcon />}
        </Nav.Item>
      </Nav>
    </Navbar>
  );
};

const NavItem = ({ desc, title, href }) => {
  return (
    <Whisper placement="auto" controlId="fexe-hover" trigger="hover" speaker={<Tooltip>{desc}</Tooltip>}>
      <Nav.Item as={NavLink} href={href}>
        {title}
      </Nav.Item>
    </Whisper>
  );
};

export default function Main() {
  const dispatch = useDispatch();
  const outlet = useOutlet();
  const [expand, setExpand] = React.useState(true);
  const navigate = useNavigate();
  const authState = useSelector((state) => state.auth);
  const certificados = useSelector(selectData);
  const signServiceEstatus = useSelector(selectSignService);
  const mhRecepcionServiceEstatus = useSelector(selectMHRecepcionService);
  useEffect(() => {
    if (authState.user.roleId === 100) dispatch(requestCertAsync({ pagination: { NumberPage: 1, SizePage: 10 } }));

    dispatch(requestSignServiceHandshakeAsync());
    dispatch(requestMHRecepcionServiceHandshakeAsync());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="show-fake-browser sidebar-page">
      <Container>
        <Sidebar style={{ display: 'flex', flexDirection: 'column' }} width={expand ? 200 : 56} collapsible>
          <Sidenav.Header>
            <div style={headerStyles}>
              <img height={50} src="/logo-detecno.png" alt="Logo" />
            </div>
          </Sidenav.Header>
          <Sidenav expanded={expand}>
            <Sidenav.Body>
              <Nav>
                {/* <Nav.Item eventKey="1" icon={<DashboardIcon />}>
                  Dashboard
                </Nav.Item> */}
                <Nav.Menu eventKey="2" trigger="hover" title="DTEs" icon={<FolderFillIcon />} placement="rightStart">
                  <NavItem href="/main/fe" desc="Factura electrónica (FE)" title="FE" />
                  <NavItem href="/main/fexe" desc="Factura de exportación electrónica (FEXE)" title="FEXE" />
                  <NavItem href="/main/fse" desc="Factura de sujeto excluido (FSE)" title="FSE" />
                  <NavItem href="/main/ccfe" desc="Comprobante de crédito fiscal electrónico (CCFE)" title="CCFE" />
                  <NavItem href="/main/nre" desc="Nota de remisión electrónica (NRE)" title="NRE" />
                  <NavItem href="/main/nce" desc="Nota de crédito electrónica (NCE)" title="NCE" />
                  <NavItem href="/main/nde" desc="Nota de debito electrónica (NDE)" title="NDE" />
                  <NavItem href="/main/cle" desc="Comprobante de liquidación electrónico (CLE)" title="CLE" />
                  <NavItem href="/main/cre" desc="Comprobante de retención IVA electrónico (CRE)" title="CRE" />
                  <NavItem href="/main/dcle" desc="Documento contable de liquidación electrónico (DCLE)" title="DCLE" />
                </Nav.Menu>
                {authState.user.roleId === 100 && (
                  <Nav.Item eventKey="5" icon={<FolderFillIcon />} as={NavLink} href={`/main/explorer`}>
                    Explorador
                  </Nav.Item>
                )}
                {authState.user.roleId === 101 && (
                  <Nav.Item eventKey="5" icon={<UserBadgeIcon />} as={NavLink} href={`/main/misempresas`}>
                    Mis Emisores
                  </Nav.Item>
                )}
                {authState.user.roleId === 100 && (
                  <Nav.Menu eventKey="3" trigger="hover" title="Administrar" icon={<GearCircleIcon />} placement="rightStart">
                    <Nav.Item as={NavLink} href={`/main/users`}>
                      Usuarios
                    </Nav.Item>
                    <Nav.Item as={NavLink} href="/main/empresas">
                      Emisores
                    </Nav.Item>
                    <Nav.Item as={NavLink} href="/main/certificados">
                      Certificados
                    </Nav.Item>
                  </Nav.Menu>
                )}
              </Nav>
            </Sidenav.Body>
          </Sidenav>
          {/* 
          //TODOAgregar numero de version
           */}
          {/* <Button>Version 1.0.0</Button>  */}
          <NavToggle expand={expand} onChange={() => setExpand(!expand)} />
        </Sidebar>
        <Container style={contentStyles}>
          <div style={{padding: 15}}>
            {certificados.recordsTotal === 0 && (
                <Message showIcon type="warning" header={'Atención. No tienes certificados cargados activos en la plataforma.'}>
                  <p>Para poder emitir documentos es necesario cargar al menos un certificado de firma electrónica.</p>
                  <hr />
                  <Button color="primary" appearance={'ghost'} onClick={() => navigate('/main/certificados')}>
                    Cargar certificado
                  </Button>
                </Message>
            )}
            {!signServiceEstatus.isAvailable && (
                <Message showIcon closable type="error" header={'Atención. El servicio de firma de documentos no está disponible.'}>
                  <p>
                    No se pudo comprobar la disponibilidad del servicio de firma de documentos, por el momento no es posible firmar
                    documentos durante la emisión.
                  </p>
                </Message>
            )}
            {!mhRecepcionServiceEstatus.isAvailable && (
                <Message
                  showIcon           
                  closable       
                  type="warning"
                  header={'Atención. El servicio de recepción de documentos del ministerio de hacienda no está disponible.'}
                >
                  <p>
                    No se pudo comprobar la disponibilidad del servicio de recepción de documentos del ministerio de hacienda. Posible
                    evento de contingencia. Se estarán emitiendo los DTE de manera diferida.{' '}
                  </p>
                </Message>
            )}
          </div>
          <Content>{outlet}</Content>
        </Container>
      </Container>
    </div>
  );
}
